import { GradientConfig } from '@repo/types';

/**
 * A CMS layout gradient as a CSS `background-image` value.
 *
 * Shared because this was byte-identical copy-paste in four files — `packages/ui`'s
 * `GeneratePage/Row.tsx` plus the admin page builder's `GeneratePage/Row.tsx`,
 * `CmsPageBuilder/Row.tsx` and `CmsPageBuilder/Column.tsx`. The public site and the admin
 * canvas must render an editor's gradient identically, so four copies that could drift is
 * exactly the wrong shape for it.
 *
 * Returns `undefined` for a gradient with fewer than two stops — there is nothing to
 * interpolate between, and the caller falls back to a plain background image.
 */
export const generateGradientCSS = (gradient: GradientConfig | undefined): string | undefined => {
  if (!gradient || gradient.stops.length < 2) return undefined;

  const sortedStops = [...gradient.stops].sort((a, b) => a.position - b.position);
  const stopsString = sortedStops.map((stop) => `${stop.color} ${stop.position}%`).join(', ');

  if (gradient.type === 'radial') {
    return `radial-gradient(circle, ${stopsString})`;
  }
  return `linear-gradient(${gradient.angle ?? 90}deg, ${stopsString})`;
};
